export default "__VITE_ASSET__D2K6pdWB__"